module.exports = __webpack_public_path__ + "static/media/stk-free-gift-en.16c253a6.png";